import { extendObservable, runInAction } from 'mobx';

/*
  This class provides an observable that dictates the width of the screen
  at any given time. This is done using the 'resize' event of the browser.
  It's important to note that the observable will *eventually* update to the
  correct value, it's *not* instant. This is because the 'resize' event is
  usually fired in a burst, so the store waits some time before making an
  update.
*/

const TIMEOUT_INTERVAL = 500;
class ScreenStoreClass {
  constructor() {
    extendObservable(this, {
      screenWidth: window.innerWidth,
    });
    this._timeout = null;
    this._queueScreenUpdate = this._queueScreenUpdate.bind(this);
    this._updateScreenSize = this._updateScreenSize.bind(this);

    // Set resize event callback
    window.addEventListener('resize', this._queueScreenUpdate);
  }

  _queueScreenUpdate() {
    if (!this._timeout) {
      this._timeout = window.setTimeout(this._updateScreenSize, TIMEOUT_INTERVAL);
    }
  }

  _updateScreenSize() {
    runInAction(() => {
      this.screenWidth = window.innerWidth;
    });
    this._timeout = null;
  }
}

const ScreenStore = new ScreenStoreClass();

export { ScreenStore };



// WEBPACK FOOTER //
// ./src/stores/ScreenStore.js